import { PropTypes } from 'prop-types';

import HeroBox from '../HeroBox/HeroBox';

function Error(props) {
  const { children = null, errorMessage, errorReference = null, heroHeaderTitles } = props;

  if (!heroHeaderTitles) return null;

  return (
    <HeroBox
      backgroundIcon="fa-exclamation-triangle"
      headerIcon={{ isSVG: false, headerIcon: 'fa-exclamation-triangle' }}
      headerTitles={heroHeaderTitles}
      displayBoxShadow={false}
    >
      <div className="error-component">
        {errorReference && (
          <div className="error__ref">
            Error Reference:
            <span className="error__ref-value">{errorReference}</span>
          </div>
        )}
        <div className="error__message">{errorMessage}</div>
        <div className="error__next-step">{children}</div>
      </div>
    </HeroBox>
  );
}

Error.propTypes = {
  heroHeaderTitles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
    }),
  ).isRequired,
  errorReference: PropTypes.string,
  errorMessage: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Error;
